export const LOAD_LOGIN_PAGE = 'LOAD_LOGIN_PAGE'
